import { Star } from "lucide-react";

export const Stars = ({ value = 0, size = 14, className = "" }) => (
  <span className={`inline-flex items-center gap-0.5 ${className}`} aria-label={`${value} out of 5 stars`}>
    {[1, 2, 3, 4, 5].map((i) => (
      <Star
        key={i}
        style={{ width: size, height: size }}
        className={i <= Math.round(value) ? "fill-brass text-brass" : "text-brass/40"}
      />
    ))}
  </span>
);
